import { D as he } from "./root-families-DFfTBmN0.js";
import { nameComponents as h } from "@messenger/consts";
const de = {
  fontFamily: he,
  fontSizePt: 10.5,
  fontWeight: 400,
  fontStyle: "normal",
  color: "#000000"
}, ke = de.fontSizePt, Re = {
  textAlign: "start",
  lineHeight: 1
}, Te = {}, re = {
  block: 0,
  run: 1
}, W = [
  "fontFamily",
  "fontSizePt",
  "fontWeight",
  "fontStyle",
  "color",
  "textDecoration",
  "textDecorationColor",
  "letterSpacing",
  "textCase",
  "textStrokeWidth",
  "textStrokeColor",
  "textFillColor"
], Ie = ["textAlign", "lineHeight", "overflowWrap"], A = [...W, ...Ie], Se = [
  "background",
  "borderWidth",
  "borderStyle",
  "borderColor",
  "borderRadius",
  "opacity",
  "verticalAlign",
  "textShadow"
], x = {
  floor: { rank: 1, allows: "all" },
  global: { rank: 2, allows: new Set(A) },
  theme: { rank: 3, allows: new Set(A) },
  product: { rank: 4, allows: new Set(A) },
  box: { rank: 5, allows: new Set(Se) },
  decoration: { rank: 6, allows: new Set(A) },
  block: { rank: 7, allows: new Set(A) },
  character: { rank: 8, allows: new Set(W) }
}, Ae = (e, t) => {
  const r = x[e];
  return r.allows === "all" || r.allows.has(t);
}, Oe = (e) => {
  const t = { ...de }, r = t;
  for (const o of e)
    for (const n of W) ye(r, o, n);
  return t;
}, ye = (e, t, r) => {
  const o = t[r];
  o !== void 0 && (e[r] = o);
}, ge = (e) => {
  const t = { ...Re };
  for (const r of e)
    r.textAlign !== void 0 && (t.textAlign = r.textAlign), r.lineHeight !== void 0 && (t.lineHeight = r.lineHeight), r.fontSizePt !== void 0 && (t.fontSizePt = r.fontSizePt), r.overflowWrap !== void 0 && (t.overflowWrap = r.overflowWrap);
  return t;
}, Ce = (e) => {
  const t = { ...Te };
  for (const r of e)
    r.background !== void 0 && (t.background = r.background), r.borderWidth !== void 0 && (t.borderWidth = r.borderWidth), r.borderStyle !== void 0 && (t.borderStyle = r.borderStyle), r.borderColor !== void 0 && (t.borderColor = r.borderColor), r.borderRadius !== void 0 && (t.borderRadius = r.borderRadius), r.opacity !== void 0 && (t.opacity = r.opacity), r.verticalAlign !== void 0 && (t.verticalAlign = r.verticalAlign), r.textShadow !== void 0 && (t.textShadow = r.textShadow);
  return t;
}, Pe = (e) => {
  const t = e;
  return Object.keys(t).filter((r) => t[r] !== void 0);
}, G = (e) => {
  for (const t of e)
    for (const r of Pe(t.delta))
      if (!Ae(t.layer, r))
        throw new Error(
          `layer-capability: layer "${t.layer}" may not carry "${r}"`
        );
}, oe = (e) => {
  const t = e;
  return JSON.stringify(
    Object.keys(t).sort().map((r) => [r, t[r]])
  );
}, Ne = (e) => e.slice().sort((t, r) => {
  const o = x[t.layer].rank, n = x[r.layer].rank;
  if (o !== n) return o - n;
  const a = re[t.scope], i = re[r.scope];
  if (a !== i) return a - i;
  if (t.sequence !== r.sequence) return t.sequence - r.sequence;
  const l = oe(t.delta), u = oe(r.delta);
  return l < u ? -1 : l > u ? 1 : 0;
}), K = (e) => Ne(e).map((t) => t.delta), ne = (e) => (G(e), Oe(K(e))), ve = (e) => (G(e), ge(K(e))), Le = (e) => (G(e), Ce(K(e))), F = (e) => Math.max(0, Math.min(255, Math.round(e))).toString(16).padStart(2, "0"), De = (e) => {
  if (e.derivationKind === "transparent") return "transparent";
  const [t, r, o] = e.components;
  return `#${F(t ?? 0)}${F(r ?? 0)}${F(o ?? 0)}`;
}, C = (e, t) => {
  const r = e.colors[t];
  if (r === void 0)
    throw new Error(
      `editor-styling: color "${t}" is not in the page content bundle`
    );
  return De(r);
}, Fe = (e, t) => {
  const r = e.fontFamilies[t];
  if (r === void 0)
    throw new Error(
      `editor-styling: font family "${t}" is not in the page content bundle`
    );
  return r.familyName;
}, xe = (e) => {
  if (e === "normal") return 400;
  if (e === "bold") return 700;
  const t = Number(e);
  return Number.isFinite(t) ? t : 400;
}, ue = (e, t, r) => {
  const o = e.stylings[t];
  if (o === void 0)
    throw new Error(
      `editor-styling: styling "${t}" is not in the page content bundle`
    );
  if (o.scope !== r)
    throw new Error(
      `editor-styling: styling "${t}" is ${o.scope}-scope; a ${r}-scope styling was required`
    );
  return o;
}, we = (e, t) => {
  const r = {};
  return e.fontFamilyId !== null ? r.fontFamily = Fe(t, e.fontFamilyId) : e.fontFamilyVerbatim !== null && (r.fontFamily = e.fontFamilyVerbatim), e.fontSize !== null && (r.fontSizePt = e.fontSize), e.fontWeight !== null && (r.fontWeight = xe(e.fontWeight)), e.fontStyle !== null && (r.fontStyle = e.fontStyle), e.colorId !== null && (r.color = C(t, e.colorId)), e.textDecoration !== null && (r.textDecoration = e.textDecoration), e.textDecorationColorId !== null && (r.textDecorationColor = C(t, e.textDecorationColorId)), e.letterSpacing !== null && (r.letterSpacing = e.letterSpacing), e.textCase !== null && (r.textCase = e.textCase), e.textStrokeWidth !== null && (r.textStrokeWidth = e.textStrokeWidth), e.textStrokeColorId !== null && (r.textStrokeColor = C(t, e.textStrokeColorId)), e.textFillColorId !== null && (r.textFillColor = C(t, e.textFillColorId)), r;
}, Me = (e) => {
  const t = {};
  return e.textAlign !== null && (t.textAlign = e.textAlign), e.lineHeight !== null && (t.lineHeight = e.lineHeight), e.fontSize !== null && (t.fontSizePt = e.fontSize), e.overflowWrap !== null && (t.overflowWrap = e.overflowWrap), t;
}, P = (e, t, r, o, n) => n === null ? [] : [
  {
    layer: e,
    scope: t,
    sequence: r,
    delta: we(
      ue(o, n, "character"),
      o
    )
  }
], w = (e, t, r, o) => o === null ? [] : [
  {
    layer: e,
    scope: "block",
    sequence: t,
    delta: Me(
      ue(r, o, "block")
    )
  }
], Ue = (e) => {
  const t = [
    { layer: "global", sequence: 0, ...e.global },
    ...e.theme === null ? [] : [{ layer: "theme", sequence: 0, ...e.theme }],
    ...e.product === null ? [] : [{ layer: "product", sequence: 0, ...e.product }],
    ...e.m3Product === null ? [] : [{ layer: "product", sequence: 1, ...e.m3Product }]
  ];
  return {
    character: t.flatMap(
      (r) => P(
        r.layer,
        "block",
        r.sequence,
        e,
        r.characterStylingId
      )
    ),
    block: t.flatMap(
      (r) => w(r.layer, r.sequence, e, r.blockStylingId)
    )
  };
}, Ve = (e) => {
  const t = {};
  return e.backgroundColor !== null && (t.background = e.backgroundColor), e.borderWidth !== null && (t.borderWidth = e.borderWidth), e.borderStyle !== null && (t.borderStyle = e.borderStyle), e.borderColor !== null && (t.borderColor = e.borderColor), e.borderRadius !== null && (t.borderRadius = e.borderRadius), e.opacity !== null && (t.opacity = e.opacity), e.verticalAlign !== null && (t.verticalAlign = e.verticalAlign), e.textShadow !== null && (t.textShadow = e.textShadow), t;
}, He = (e, t, r) => {
  const o = e.role === null ? void 0 : r.decorations.find((i) => i.role === e.role), n = [
    ...t.character,
    ...P(
      "decoration",
      "block",
      0,
      r,
      (o == null ? void 0 : o.characterStylingId) ?? null
    ),
    ...P("block", "block", 0, r, e.characterStylingId)
  ], a = ve([
    ...t.block,
    ...w(
      "decoration",
      0,
      r,
      (o == null ? void 0 : o.blockStylingId) ?? null
    ),
    ...w("block", 0, r, e.blockStylingId)
  ]);
  if (e.runs.length === 0) {
    const i = ne(n).fontSizePt;
    a.fontSizePt === void 0 ? i !== ke && (a.fontSizePt = i) : i > a.fontSizePt && (a.fontSizePt = i);
  }
  return {
    blockId: e.id,
    style: a,
    runs: e.runs.map((i) => ({
      runId: i.id,
      style: ne([
        ...n,
        ...P(
          "character",
          "run",
          0,
          r,
          i.characterStylingId
        )
      ])
    }))
  };
}, Bt = (e, t) => {
  const r = Ue(t), o = Ve(e), n = Le(
    Object.keys(o).length === 0 ? [] : [{ layer: "box", scope: "block", sequence: 0, delta: o }]
  );
  return {
    boxId: e.boxId,
    style: n,
    blocks: e.blocks.map(
      (a) => He(a, r, t)
    )
  };
}, v = [
  { codePoint: 9, name: "CHARACTER TABULATION", cls: "collapsible-space" },
  { codePoint: 10, name: "LINE FEED", cls: "line-structure" },
  { codePoint: 13, name: "CARRIAGE RETURN", cls: "line-structure", mapsTo: 10 },
  // prettier-ignore
  { codePoint: 32, name: "SPACE", cls: "collapsible-space" },
  { codePoint: 127, name: "DELETE", cls: "forbidden" },
  { codePoint: 160, name: "NO-BREAK SPACE", cls: "authored-whitespace" },
  { codePoint: 173, name: "SOFT HYPHEN", cls: "artifact" },
  { codePoint: 1564, name: "ARABIC LETTER MARK", cls: "text" },
  { codePoint: 8206, name: "LEFT-TO-RIGHT MARK", cls: "text" },
  { codePoint: 8207, name: "RIGHT-TO-LEFT MARK", cls: "text" },
  { codePoint: 8234, name: "LEFT-TO-RIGHT EMBEDDING", cls: "text" },
  { codePoint: 8235, name: "RIGHT-TO-LEFT EMBEDDING", cls: "text" },
  { codePoint: 8236, name: "POP DIRECTIONAL FORMATTING", cls: "text" },
  { codePoint: 8237, name: "LEFT-TO-RIGHT OVERRIDE", cls: "text" },
  { codePoint: 8238, name: "RIGHT-TO-LEFT OVERRIDE", cls: "text" },
  { codePoint: 8294, name: "LEFT-TO-RIGHT ISOLATE", cls: "text" },
  { codePoint: 8295, name: "RIGHT-TO-LEFT ISOLATE", cls: "text" },
  { codePoint: 8296, name: "FIRST STRONG ISOLATE", cls: "text" },
  { codePoint: 8297, name: "POP DIRECTIONAL ISOLATE", cls: "text" },
  { codePoint: 5760, name: "OGHAM SPACE MARK", cls: "collapsible-space" },
  { codePoint: 8192, name: "EN QUAD", cls: "collapsible-space" },
  { codePoint: 8193, name: "EM QUAD", cls: "collapsible-space" },
  { codePoint: 8194, name: "EN SPACE", cls: "collapsible-space" },
  { codePoint: 8195, name: "EM SPACE", cls: "collapsible-space" },
  { codePoint: 8196, name: "THREE-PER-EM SPACE", cls: "collapsible-space" },
  { codePoint: 8197, name: "FOUR-PER-EM SPACE", cls: "collapsible-space" },
  { codePoint: 8198, name: "SIX-PER-EM SPACE", cls: "collapsible-space" },
  { codePoint: 8199, name: "FIGURE SPACE", cls: "collapsible-space" },
  { codePoint: 8200, name: "PUNCTUATION SPACE", cls: "collapsible-space" },
  { codePoint: 8201, name: "THIN SPACE", cls: "collapsible-space" },
  { codePoint: 8202, name: "HAIR SPACE", cls: "artifact" },
  { codePoint: 8239, name: "NARROW NO-BREAK SPACE", cls: "authored-whitespace" },
  // prettier-ignore
  { codePoint: 8287, name: "MEDIUM MATHEMATICAL SPACE", cls: "collapsible-space" },
  // prettier-ignore
  { codePoint: 12288, name: "IDEOGRAPHIC SPACE", cls: "authored-whitespace" },
  { codePoint: 8203, name: "ZERO WIDTH SPACE", cls: "artifact" },
  { codePoint: 8204, name: "ZERO WIDTH NON-JOINER", cls: "text" },
  { codePoint: 8205, name: "ZERO WIDTH JOINER", cls: "text" },
  { codePoint: 8232, name: "LINE SEPARATOR", cls: "line-structure", mapsTo: 10 },
  // prettier-ignore
  { codePoint: 8233, name: "PARAGRAPH SEPARATOR", cls: "line-structure", mapsTo: 10 },
  // prettier-ignore
  { codePoint: 8288, name: "WORD JOINER", cls: "artifact" },
  { codePoint: 65038, name: "VARIATION SELECTOR-15", cls: "text" },
  { codePoint: 65039, name: "VARIATION SELECTOR-16", cls: "text" },
  { codePoint: 65279, name: "ZERO WIDTH NO-BREAK SPACE (BOM)", cls: "artifact" },
  // prettier-ignore
  { codePoint: 65532, name: "OBJECT REPLACEMENT CHARACTER", cls: "artifact" }
], Be = new Map(
  v.map((e) => [e.codePoint, e.cls])
), $e = (e) => e <= 8 || e === 11 || e === 12 || e >= 14 && e <= 31, $t = (e) => Be.get(e) ?? ($e(e) ? "forbidden" : "text"), We = new Map(
  v.flatMap(
    (e) => "mapsTo" in e ? [[e.codePoint, e.mapsTo]] : []
  )
), Wt = (e) => We.get(e), M = (e) => v.filter((t) => t.cls === e).map(
  (t) => String.fromCodePoint(t.codePoint)
), Gt = (e, t = "g") => new RegExp(
  `[${v.filter((r) => r.cls === e).map((r) => `\\u{${r.codePoint.toString(16)}}`).join("")}]`,
  t.includes("u") ? t : `${t}u`
), k = (e) => String.fromCodePoint(e), Kt = k(160), zt = k(173), Yt = k(8202), jt = k(8203), Xt = k(8288), qt = k(65279), Jt = k(65532), Ge = /* @__PURE__ */ new Set([
  ...M("collapsible-space"),
  ...M("authored-whitespace")
]), Ke = new Set(
  M("artifact")
), z = (e) => e === " " || Ge.has(e), U = (e) => Ke.has(e), Zt = (e, t) => {
  const r = /* @__PURE__ */ new Map(), o = [], n = /* @__PURE__ */ new Set();
  for (const i of t)
    n.has(i.piece) || (n.add(i.piece), o.push(i.piece)), i.kind === "char" && r.set(i.piece, (r.get(i.piece) ?? "") + i.ch);
  const a = [];
  for (const i of o) {
    const l = e[i];
    if (l.kind === "field") {
      a.push(l);
      continue;
    }
    const u = r.get(i) ?? "";
    u !== "" && a.push(u === l.text ? l : { ...l, text: u });
  }
  return a;
}, ze = (e, t) => t.length === e.length && t.every((r, o) => r === e[o]) ? e : t, Ye = /* @__PURE__ */ new Set([
  ",",
  ";",
  ":",
  "/",
  "&",
  "|",
  "-",
  "–",
  "—",
  "·",
  "•"
]), je = /* @__PURE__ */ new Set([
  ".",
  "!",
  "?",
  "…"
]), ae = /* @__PURE__ */ new Map([
  ["(", ")"],
  ["[", "]"],
  ["{", "}"],
  ['"', '"'],
  ["'", "'"],
  ["“", "”"],
  ["‘", "’"],
  ["«", "»"],
  ["‹", "›"]
]), Xe = /* @__PURE__ */ new Set([
  ...je,
  ...ae.keys(),
  ...ae.values()
]), qe = (e) => {
  let t = "", r = !1;
  for (const o of e) {
    if (o === `
`) {
      t += o, r = !1;
      continue;
    }
    if (z(o)) {
      r || (t += " "), r = !0;
      continue;
    }
    t += o, r = !1;
  }
  return t;
}, Je = (e) => {
  for (const t of e)
    if (!z(t) && !U(t) && t !== `
`)
      return !1;
  return !0;
}, Ze = (e) => e.ch === `
`, Qe = (e, t = {}) => {
  const r = t.asTyped === !0, o = [], n = [], a = [];
  let i = !1;
  e.forEach((_, c) => {
    if (_.kind === "literal") {
      for (const R of _.text)
        o.push({ ch: R, piece: c, field: !1 }), a.push(!0);
      return;
    }
    i = !0;
    const d = _.resolvedText ?? "", O = Je(d);
    O && n.push({ at: o.length, piece: c, abandoned: [] });
    for (const R of d) {
      const y = R !== `
` && z(R) ? " " : R;
      o.push({ ch: y, piece: c, field: !0 }), a.push(!O);
    }
  });
  const l = /* @__PURE__ */ new Map();
  n.forEach((_, c) => {
    const d = l.get(_.at);
    d === void 0 ? l.set(_.at, [c]) : d.push(c);
  });
  const u = [];
  let b = 0;
  o.forEach((_, c) => {
    Ze(_) && (u.push({ from: b, to: c }), b = c + 1);
  }), u.push({ from: b, to: o.length });
  for (const _ of u) {
    const { from: c, to: d } = _, O = (s, f) => {
      const m = l.get(s);
      if (m !== void 0)
        return f === 1 ? m[0] : m[m.length - 1];
    };
    if (!(() => {
      for (let s = c; s <= d; s++) if (l.has(s)) return !0;
      for (let s = c; s < d; s++) if (o[s].field && a[s]) return !0;
      return !1;
    })()) continue;
    const y = (s, f, m) => {
      let E = s;
      for (; ; ) {
        const L = f === 1 ? E + 1 : E, te = O(L, f);
        if (te !== void 0 && L >= c && L <= d)
          return { kind: "empty-field", walk: te };
        if (E += f, E < c || E >= d) return { kind: "edge" };
        const D = o[E];
        if (!(!a[E] || U(D.ch)) && !(m && D.ch === " "))
          return D.field ? { kind: "filled-field" } : { kind: "literal" };
      }
    }, Q = (s, f) => {
      const m = y(s, -1, f), E = y(s, 1, f);
      return m.kind !== "empty-field" && E.kind !== "empty-field" ? !1 : (a[s] = !1, m.kind === "empty-field" && n[m.walk].abandoned.push(s), E.kind === "empty-field" && n[E.walk].abandoned.push(s), !0);
    };
    let g = !0;
    for (; g; ) {
      g = !1;
      for (let s = c; s < d; s++) {
        if (!a[s] || o[s].field) continue;
        const f = o[s].ch;
        Xe.has(f) && Q(s, !1) && (g = !0);
      }
      for (let s = c; s < d; s++) {
        if (!a[s] || o[s].field) continue;
        const f = o[s].ch;
        Ye.has(f) && Q(s, !0) && (g = !0);
      }
    }
    const ee = (s) => !a[s] || U(o[s].ch) || o[s].ch === " " && (!r || o[s].field);
    for (let s = c; s < d && ee(s); s++) a[s] = !1;
    for (let s = d - 1; s >= c && ee(s); s--) a[s] = !1;
    let p = -1, T = !1;
    for (let s = c; s < d; s++) {
      if (l.has(s) && p >= 0 && (T = !0), !a[s]) {
        p >= 0 && (T = !0);
        continue;
      }
      const f = o[s];
      if (f.ch !== " ") {
        p = -1, T = !1;
        continue;
      }
      if (p >= 0 && (!r || T || f.field || o[p].field)) {
        o[p].field && !f.field ? (a[p] = !1, p = s) : a[s] = !1, T = !1;
        continue;
      }
      p = s, T = !1;
    }
  }
  for (const _ of n) _.abandoned.sort((c, d) => c - d);
  return { chars: o, keep: a, walks: n, hasField: i };
}, Qt = (e) => e.hasField && e.chars.every((t, r) => !e.keep[r] || t.ch === " "), er = (e) => {
  const { chars: t, keep: r } = Qe(e), o = /* @__PURE__ */ new Map();
  t.forEach((a, i) => {
    r[i] && o.set(a.piece, (o.get(a.piece) ?? "") + a.ch);
  });
  const n = [];
  return e.forEach((a, i) => {
    const l = o.get(i) ?? "";
    if (a.kind === "field") {
      n.push(
        l === (a.resolvedText ?? "") ? a : { ...a, resolvedText: l }
      );
      return;
    }
    l !== "" && n.push(l === a.text ? a : { ...a, text: l });
  }), ze(e, n);
}, Y = {
  prefix: "name_prefix",
  first: "name_first",
  nickname: "name_nickname",
  middle: "name_middle",
  maiden: "name_maiden",
  last: "name_last",
  suffix: "name_suffix"
}, S = [
  h.prefix,
  h.first,
  h.nickname,
  h.middle,
  h.maiden,
  h.last,
  h.suffix
], tr = (e) => S.includes(e), I = "name-of-deceased", j = "name_arrangement:order", X = "name_arrangement:hidden", rr = (e) => ({
  [j]: e.order.join(","),
  [X]: e.hidden.join(",")
}), or = (e) => {
  const {
    [j]: t,
    [X]: r,
    ...o
  } = e;
  return o;
}, et = (e) => {
  const t = e[j];
  if (!t) return;
  const r = (e[X] ?? "").split(",").filter((o) => o !== "");
  return {
    order: t.split(","),
    visibility: Object.fromEntries(r.map((o) => [o, !1]))
  };
}, tt = (e) => {
  const t = (e == null ? void 0 : e.order) ?? S, r = (e == null ? void 0 : e.visibility) ?? {};
  return t.filter((o) => r[o] !== !1);
}, rt = (e) => {
  if (!e) return !0;
  const t = e.order === void 0 || e.order.length === S.length && e.order.every((o, n) => o === S[n]), r = e.visibility === void 0 || Object.values(e.visibility).every((o) => o !== !1);
  return t && r;
}, q = "final-resting", J = "service_column", V = (e, t) => `service_col:${e}:${t}`, Z = (e) => `service_index_id:${e}`, se = (e, t, r) => e.length >= 2 && e.startsWith(t) && e.endsWith(r), fe = (e) => qe(e ?? "").trim(), ot = (e, t) => {
  switch (e) {
    case "nickname":
      return se(t, '"', '"') ? t : `"${t}"`;
    case "middle":
      return Ee(t);
    case "maiden":
      return se(t, "(", ")") ? t : `(${t})`;
    default:
      return t;
  }
}, _e = (e, t = S) => t.flatMap((r) => {
  const o = fe(e[r]);
  return o === "" ? [] : [
    {
      part: r,
      fieldKey: Y[r] ?? r,
      text: ot(r, o)
    }
  ];
}), nr = (e, t = S) => _e(e, t).map((r) => r.text).join(" "), nt = (e, t) => {
  const r = fe(e[I]), o = r === "" ? [] : [
    {
      part: I,
      fieldKey: I,
      text: r
    }
  ], n = et(e) ?? t, a = !rt(n);
  if (r !== "" && !a) return o;
  const i = tt(n), l = _e(
    Object.fromEntries(
      i.map((u) => {
        const b = Y[u];
        return [u, b ? e[b] : void 0];
      })
    ),
    i
  );
  return l.length > 0 ? l : o;
}, at = (e, t) => nt(e, t).map((r) => r.text).join(" "), ar = (e, t, r) => {
  if (e === I)
    return at(t, r);
  if (e === J)
    return ct(t, r);
  if (e === "service" || e === "visitation")
    return lt(e, t, r);
  if (e === q)
    return _t(t);
  if ((r == null ? void 0 : r.cellIndex) !== void 0)
    return t[me(e, r.cellIndex, r.rowType)] ?? "";
  const o = t[e];
  return o == null ? "" : e === Y.middle ? Ee(o) : o;
}, Ee = (e) => {
  const t = e.trim();
  if (!t) return t;
  const r = t.length === 1, o = t.endsWith(".");
  return r && !o ? `${t}.` : t;
}, st = [
  "location",
  "address",
  "city_state_postal",
  "date"
], it = (e, t) => `service:${e}:${t}`, N = (e) => `service_default_id:${e}`, sr = (e) => {
  const t = new Set(
    [
      e[N("service")],
      e[N("visitation")]
    ].filter((o) => o != null && o !== "")
  ), r = [];
  for (let o = 0; ; o += 1) {
    const n = e[Z(o)];
    if (n == null || n === "") return r;
    r.push({
      id: n,
      type: (e[V(n, "type")] ?? "").toLowerCase(),
      location: e[V(n, "location")] ?? "",
      isDefault: t.has(n)
    });
  }
}, lt = (e, t, r) => {
  const o = (r == null ? void 0 : r.serviceId) ?? ((r == null ? void 0 : r.serviceIndex) != null ? t[Z(r.serviceIndex)] : void 0) ?? t[N(e)];
  if (!o) return "";
  const n = (u) => t[it(o, u)] ?? "", a = st.map(n), i = n("start_time"), l = n("end_time");
  return a.push(i && l ? `${i} to ${l}` : i), a.filter((u) => u !== "").join(`
`);
}, ct = (e, t) => {
  const r = t == null ? void 0 : t.serviceColumn;
  if (!r) return "";
  const o = (t == null ? void 0 : t.serviceId) ?? e[N(
    (t == null ? void 0 : t.serviceKind) === "visitation" ? "visitation" : "service"
  )] ?? ((t == null ? void 0 : t.serviceIndex) != null ? e[Z(t.serviceIndex)] : void 0);
  return o ? e[V(o, r)] ?? "" : "";
}, dt = (e, t) => t === void 0 ? `${e}:count` : `${e}:row_type=${t}:count`, me = (e, t, r) => r === void 0 ? `${e}:${t}` : `${e}:row_type=${r}:${t}`, ut = (e, t) => `${e}:row_type_index:${t}`, ir = (e, t) => {
  const r = [];
  for (let o = 0; ; o += 1) {
    const n = t[ut(e, o)];
    if (n == null || n === "") return r;
    r.push(n);
  }
}, ft = 500, lr = (e, t, r) => {
  const o = t[dt(e, r)], n = o == null ? 0 : Number.parseInt(o, 10);
  return !Number.isFinite(n) || n <= 0 || n > ft ? [] : Array.from(
    { length: n },
    (a, i) => t[me(e, i, r)] ?? ""
  );
}, _t = (e) => [
  e.interment_place ?? "",
  e.interment_address ?? "",
  e.interment_city_state_postal ?? ""
].filter((t) => t !== "").join(`
`), pe = [
  {
    key: I,
    label: "Name of deceased",
    group: "Name",
    kind: "composite"
  },
  { key: "name_first", label: "First name", group: "Name", kind: "scalar" },
  { key: "name_last", label: "Last name", group: "Name", kind: "scalar" },
  { key: "name_prefix", label: "Prefix name", group: "Name", kind: "scalar" },
  {
    key: "name_nickname",
    label: "Nickname",
    group: "Name",
    kind: "scalar"
  },
  { key: "name_middle", label: "Middle name", group: "Name", kind: "scalar" },
  { key: "name_maiden", label: "Maiden name", group: "Name", kind: "scalar" },
  { key: "name_suffix", label: "Suffix name", group: "Name", kind: "scalar" },
  {
    key: "first_letter_first",
    label: "First letter of first name",
    group: "Name",
    kind: "scalar"
  },
  {
    key: "first_letter_middle",
    label: "First letter of middle name",
    group: "Name",
    kind: "scalar"
  },
  {
    key: "first_letter_last",
    label: "First letter of last name",
    group: "Name",
    kind: "scalar"
  },
  {
    key: "date_of_birth",
    label: "Date of birth",
    group: "Dates",
    kind: "scalar"
  },
  {
    key: "date_of_death",
    label: "Date of death",
    group: "Dates",
    kind: "scalar"
  },
  {
    key: "year_of_birth",
    label: "Year of birth",
    group: "Dates",
    kind: "scalar"
  },
  {
    key: "year_of_death",
    label: "Year of death",
    group: "Dates",
    kind: "scalar"
  },
  {
    key: "age_years",
    label: "Age in years",
    group: "Dates",
    kind: "scalar"
  },
  {
    key: "age_months",
    label: "Age in months",
    group: "Dates",
    kind: "scalar"
  },
  {
    key: "age_days",
    label: "Age in days",
    group: "Dates",
    kind: "scalar"
  },
  {
    key: "date_of_marriage",
    label: "Date of marriage",
    group: "Dates",
    kind: "scalar"
  },
  {
    key: "service",
    label: "Service details",
    group: "Services",
    kind: "composite"
  },
  {
    key: "visitation",
    label: "Visitation details",
    group: "Services",
    kind: "composite"
  },
  {
    key: "order_of_service",
    label: "Order of service",
    group: "Services",
    kind: "scalar",
    multiline: !0
  },
  {
    key: "place_of_birth",
    label: "Place of birth",
    group: "Places",
    kind: "scalar"
  },
  {
    key: "place_of_death",
    label: "Place of death",
    group: "Places",
    kind: "scalar"
  },
  {
    key: "mother_of_deceased",
    label: "Mother of deceased",
    group: "Family",
    kind: "scalar"
  },
  {
    key: "father_of_deceased",
    label: "Father of deceased",
    group: "Family",
    kind: "scalar"
  },
  { key: "spouse", label: "Spouse", group: "Family", kind: "scalar" },
  { key: "maternal_grandmother", label: "Grandmother", group: "Mother's side", kind: "scalar" },
  // prettier-ignore
  { key: "maternal_grandmothers_mother", label: "Grandmother's mother", group: "Mother's side", kind: "scalar" },
  // prettier-ignore
  { key: "maternal_grandmothers_father", label: "Grandmother's father", group: "Mother's side", kind: "scalar" },
  // prettier-ignore
  { key: "maternal_grandfather", label: "Grandfather", group: "Mother's side", kind: "scalar" },
  // prettier-ignore
  { key: "maternal_grandfathers_mother", label: "Grandfather's mother", group: "Mother's side", kind: "scalar" },
  // prettier-ignore
  { key: "maternal_grandfathers_father", label: "Grandfather's father", group: "Mother's side", kind: "scalar" },
  // prettier-ignore
  { key: "paternal_grandmother", label: "Grandmother", group: "Father's side", kind: "scalar" },
  // prettier-ignore
  { key: "paternal_grandmothers_mother", label: "Grandmother's mother", group: "Father's side", kind: "scalar" },
  // prettier-ignore
  { key: "paternal_grandmothers_father", label: "Grandmother's father", group: "Father's side", kind: "scalar" },
  // prettier-ignore
  { key: "paternal_grandfather", label: "Grandfather", group: "Father's side", kind: "scalar" },
  // prettier-ignore
  { key: "paternal_grandfathers_mother", label: "Grandfather's mother", group: "Father's side", kind: "scalar" },
  // prettier-ignore
  { key: "paternal_grandfathers_father", label: "Grandfather's father", group: "Father's side", kind: "scalar" },
  // prettier-ignore
  {
    key: "website_obit_url",
    label: "Website obituary URL",
    group: "Case",
    kind: "scalar"
  },
  {
    key: "obituary",
    label: "Obituary",
    group: "Case",
    kind: "scalar",
    multiline: !0
  },
  {
    key: "family_appreciation_message",
    label: "Family appreciation message",
    group: "Case",
    kind: "scalar",
    multiline: !0
  },
  {
    key: "printed_in",
    label: "Printed in",
    group: "Case",
    kind: "scalar"
  },
  { key: "clergy", label: "Clergy", group: "Case", kind: "tabular" },
  { key: "pallbearers", label: "Pallbearers", group: "Case", kind: "tabular" },
  { key: "honorary_pallbearers", label: "Honorary Pallbearers", group: "Case", kind: "tabular" },
  // prettier-ignore
  { key: "children", label: "Children", group: "Case", kind: "tabular" },
  { key: "siblings", label: "Siblings", group: "Case", kind: "tabular" },
  {
    key: "songs",
    label: "Songs",
    group: "Case",
    kind: "tabular"
  },
  { key: "memorial_contributions", label: "Memorial Contributions", group: "Case", kind: "tabular" },
  // prettier-ignore
  {
    key: "organizations",
    label: "Organizations",
    group: "Case",
    kind: "tabular"
  },
  { key: "additional_family", label: "Additional Family", group: "Family", kind: "tabular" },
  // prettier-ignore
  {
    key: "interment_place",
    label: "Interment place",
    group: "Interment",
    kind: "scalar"
  },
  {
    key: "interment_address",
    label: "Interment address",
    group: "Interment",
    kind: "scalar"
  },
  {
    key: "interment_city",
    label: "Interment city",
    group: "Interment",
    kind: "scalar"
  },
  {
    key: "interment_state",
    label: "Interment state",
    group: "Interment",
    kind: "scalar"
  },
  {
    key: "interment_date",
    label: "Interment date",
    group: "Interment",
    kind: "scalar"
  },
  {
    key: "interment_time",
    label: "Interment time",
    group: "Interment",
    kind: "scalar"
  },
  {
    key: "interment_postal_code",
    label: "Interment postal code",
    group: "Interment",
    kind: "scalar"
  },
  {
    key: "interment_lot",
    label: "Interment lot",
    group: "Interment",
    kind: "scalar"
  },
  {
    key: "interment_section",
    label: "Interment section",
    group: "Interment",
    kind: "scalar"
  },
  {
    key: "interment_block",
    label: "Interment block",
    group: "Interment",
    kind: "scalar"
  },
  {
    key: "interment_county",
    label: "Interment county",
    group: "Interment",
    kind: "scalar"
  },
  {
    key: q,
    label: "Final resting (interment block)",
    group: "Interment",
    kind: "composite"
  },
  {
    key: "fh:name",
    label: "Funeral home name",
    group: "Funeral home",
    kind: "scalar"
  },
  {
    key: "fh:address",
    label: "Funeral home address",
    group: "Funeral home",
    kind: "scalar"
  },
  {
    key: "fh:address_2",
    label: "Funeral home address line 2",
    group: "Funeral home",
    kind: "scalar"
  },
  {
    key: "fh:city",
    label: "Funeral home city",
    group: "Funeral home",
    kind: "scalar"
  },
  {
    key: "fh:state",
    label: "Funeral home state",
    group: "Funeral home",
    kind: "scalar"
  },
  {
    key: "fh:zip",
    label: "Funeral home ZIP",
    group: "Funeral home",
    kind: "scalar"
  },
  {
    key: "fh:city_state_zip",
    label: "Funeral home city, state ZIP",
    group: "Funeral home",
    kind: "scalar"
  },
  {
    key: "fh:phone",
    label: "Funeral home phone",
    group: "Funeral home",
    kind: "scalar"
  },
  {
    key: "fh:email",
    label: "Funeral home email",
    group: "Funeral home",
    kind: "scalar"
  },
  {
    key: "fh:website",
    label: "Funeral home website",
    group: "Funeral home",
    kind: "scalar"
  },
  { key: "birth_header", label: "Birth Header", group: "Headers", kind: "scalar" },
  // prettier-ignore
  { key: "death_header", label: "Death Header", group: "Headers", kind: "scalar" },
  // prettier-ignore
  { key: "remembrance_header", label: "Remembrance Header", group: "Headers", kind: "scalar" },
  // prettier-ignore
  { key: "final_resting_header", label: "Final Resting Header", group: "Headers", kind: "scalar" },
  // prettier-ignore
  { key: "officiating_header", label: "Officiating Header", group: "Headers", kind: "scalar" },
  // prettier-ignore
  { key: "pallbearers_header", label: "Pallbearers Header", group: "Headers", kind: "scalar" },
  // prettier-ignore
  { key: "visitation_header", label: "Visitation Header", group: "Headers", kind: "scalar" },
  // prettier-ignore
  { key: "memorial_service_header", label: "Memorial Service Header", group: "Headers", kind: "scalar" },
  // prettier-ignore
  { key: "family_appreciation_header", label: "Family Appreciation Header", group: "Headers", kind: "scalar" }
  // prettier-ignore
], Et = {
  order: { type: "string-array" },
  visibility: { type: "boolean-map" }
}, mt = {
  serviceId: { type: "string" },
  serviceIndex: { type: "number" }
}, pt = {
  serviceColumn: { type: "string", required: !0 },
  serviceId: { type: "string" },
  serviceKind: { type: "string", oneOf: ["service", "visitation"] },
  serviceIndex: { type: "number" }
}, bt = {}, ht = {
  cellIndex: { type: "number" },
  rowType: { type: "string" }
}, kt = {
  firstLetterOnly: { type: "boolean" },
  onlyShowYear: { type: "boolean" },
  capitalized: { type: "boolean" }
}, be = new Map(
  pe.map((e) => [e.key, e])
), Rt = [J], Tt = [
  ...pe.map((e) => e.key),
  ...Rt
], It = new Set(Tt), cr = (e) => It.has(e), dr = (e) => be.get(e), St = (e) => {
  if (e === I) return Et;
  if (e === "service" || e === "visitation")
    return mt;
  if (e === J) return pt;
  if (e === q) return bt;
  const t = be.get(e);
  if (t !== void 0)
    return t.kind === "tabular" ? ht : t.kind === "composite" ? {} : kt;
}, H = (e) => typeof e == "object" && e !== null && !Array.isArray(e), At = (e, t) => {
  switch (t) {
    case "string":
      return typeof e == "string";
    case "number":
      return typeof e == "number" && Number.isFinite(e);
    case "boolean":
      return typeof e == "boolean";
    case "string-array":
      return Array.isArray(e) && e.every((r) => typeof r == "string");
    case "boolean-map":
      return H(e) && Object.values(e).every((r) => typeof r == "boolean");
  }
}, Ot = {
  string: "a string",
  number: "a finite number",
  boolean: "a boolean",
  "string-array": "an array of strings",
  "boolean-map": "an object of string→boolean"
}, ur = (e, t) => {
  const r = St(e);
  if (r === void 0)
    return `names a field '${e}' the registry does not know`;
  if (t != null && !H(t))
    return "must be an object when present";
  const o = H(t) ? t : {};
  for (const n of Object.keys(o)) {
    if (o[n] === void 0) continue;
    const a = r[n];
    if (a === void 0)
      return `carries an unknown parameter '${n}' for field '${e}'`;
    if (!At(o[n], a.type))
      return `parameter '${n}' must be ${Ot[a.type]} for field '${e}'`;
    if (a.oneOf !== void 0 && !a.oneOf.includes(o[n]))
      return `parameter '${n}' must be one of ${a.oneOf.map((i) => `'${i}'`).join(", ")} for field '${e}'`;
  }
  for (const [n, a] of Object.entries(r))
    if (a.required && o[n] === void 0)
      return `is missing the required parameter '${n}' for field '${e}'`;
}, B = "editor_text_box_blocks", $ = 1, yt = /* @__PURE__ */ new Set([
  "service",
  "visitation"
]), gt = "service_column", Ct = (e, t) => yt.has(e.fieldKey) ? { ...e, fieldKey: t ? "visitation" : "service" } : e.fieldKey === gt && t ? { ...e, params: { ...e.params, serviceKind: "visitation" } } : e, Pt = (e, t) => {
  if (e.kind !== "field") return e;
  const { caseServiceId: r, ...o } = e, n = t !== void 0 && r !== void 0 ? Ct(o, t.has(r)) : o, a = n.params;
  if (a === void 0 || a.serviceId === void 0) return n;
  const { serviceId: i, ...l } = a;
  return Object.keys(l).length === 0 ? { ...n, params: void 0 } : { ...n, params: l };
}, Nt = (e) => ({
  ...e,
  runs: e.runs.map((t) => Pt(t))
}), fr = (e) => JSON.stringify({
  kind: B,
  version: $,
  blocks: e.map(Nt)
}), _r = (e) => {
  if (typeof e != "string") return null;
  const t = e.trim();
  if (!t.startsWith("{")) return null;
  let r;
  try {
    r = JSON.parse(t);
  } catch {
    return null;
  }
  if (typeof r != "object" || r === null || Array.isArray(r))
    return null;
  const o = r;
  return o.kind !== B || o.version !== $ || !Array.isArray(o.blocks) ? null : {
    kind: B,
    version: $,
    blocks: o.blocks
  };
}, vt = /[;{}<>"'\\\n\r\t\f]/g, ie = (e) => e.replace(vt, ""), Er = (e) => e.replace(/\\/g, "\\\\").replace(/'/g, "\\'").replace(/[<>"]/g, ""), le = String.raw`url\([^)"'<>]*\)`, ce = String.raw`format\(\s*(?:"[^"<>]*"|'[^'<>]*')\s*\)`, Lt = new RegExp(
  `^\\s*${le}(?:\\s+${ce})?(?:\\s*,\\s*${le}(?:\\s+${ce})?)*\\s*$`
), mr = (e) => Lt.test(e) ? e : "local('')", pr = (e) => {
  const t = [];
  for (const r of e.split(";")) {
    const o = r.indexOf(":");
    if (o === -1) continue;
    const n = ie(r.slice(0, o).trim()), a = ie(r.slice(o + 1).trim());
    n !== "" && a !== "" && t.push(`${n}:${a}`);
  }
  return t.join(";");
}, br = (e) => {
  if (!Number.isFinite(e)) return "0";
  let r = (Math.round(e * 1e4) / 1e4).toFixed(4);
  return r = r.replace(/\.?0+$/, ""), r === "-0" ? "0" : r;
}, Dt = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i, Ft = /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d*\.?\d+)\s*)?\)$/i, hr = (e) => {
  const t = e.trim(), r = Dt.exec(t);
  if (r) {
    const u = r[1].length === 3 ? r[1].replace(/./g, (d) => d + d) : r[1], [b, _, c] = [0, 2, 4].map((d) => parseInt(u.slice(d, d + 2), 16));
    return { r: b, g: _, b: c, a: 1 };
  }
  const o = Ft.exec(t);
  if (!o) return null;
  const [n, a, i] = [o[1], o[2], o[3]].map(Number), l = o[4] === void 0 ? 1 : Number(o[4]);
  return n > 255 || a > 255 || i > 255 || l > 1 ? null : { r: n, g: a, b: i, a: l };
}, kr = 1e5, Rr = 5e3, Tr = 2e3, Ir = ["character", "block"], Sr = ["normal", "italic", "oblique"], Ar = ["normal", "none"], Or = [
  "normal",
  "none",
  "common-ligatures",
  "no-common-ligatures",
  "discretionary-ligatures",
  "no-discretionary-ligatures",
  "historical-ligatures",
  "no-historical-ligatures",
  "contextual",
  "no-contextual"
], yr = [
  "normal",
  "small-caps",
  "all-small-caps",
  "petite-caps",
  "all-petite-caps",
  "unicase",
  "titling-caps"
], gr = [
  "normal",
  "ordinal",
  "slashed-zero",
  "lining-nums",
  "oldstyle-nums",
  "proportional-nums",
  "tabular-nums",
  "diagonal-fractions",
  "stacked-fractions"
], Cr = [
  "normal",
  "sub",
  "super"
], Pr = [
  "normal",
  "jis78",
  "jis83",
  "jis90",
  "jis04",
  "simplified",
  "traditional",
  "full-width",
  "proportional-width",
  "ruby"
], Nr = [
  "normal",
  "historical-forms"
], vr = [
  "normal",
  "text",
  "emoji",
  "unicode"
], Lr = [
  "none",
  "underline",
  "overline",
  "line-through"
], Dr = [
  "none",
  "uppercase",
  "lowercase",
  "capitalize"
], Fr = [
  "auto",
  "optimizeSpeed",
  "optimizeLegibility",
  "geometricPrecision"
], xr = [
  "start",
  "end",
  "center",
  "justify"
], wr = ["inter-word"], Mr = ["wrap", "nowrap"], Ur = ["none"], Vr = [
  "normal",
  "strict",
  "loose",
  "anywhere"
], Hr = [
  "normal",
  "break-all",
  "keep-all",
  "break-word"
], Br = [
  "normal",
  "break-word",
  "anywhere"
], $r = ["manual", "none"], Wr = [
  "normal",
  "nowrap",
  "pre",
  "pre-wrap",
  "pre-line",
  "break-spaces"
], Gr = ["ltr", "rtl"], Kr = [
  "normal",
  "embed",
  "isolate",
  "bidi-override",
  "isolate-override",
  "plaintext"
], zr = ["ltr", "rtl"], Yr = [
  "none",
  "solid",
  "dashed",
  "dotted",
  "double"
], jr = [
  "top",
  "middle",
  "bottom"
], Xr = [
  "horizontal-tb",
  "vertical-rl",
  "vertical-lr"
], qr = [
  "natural",
  "shrink",
  "fill",
  "solid"
], Jr = ["template", "user"], Zr = ["break-word"], Qr = [
  "body",
  "heading",
  "deceased_name",
  "subheading",
  "footer"
], eo = [
  "paragraph",
  "rule",
  "case_detail_table",
  "literal_grid"
], to = ["text", "field"], xt = [
  "srgb",
  "srgb_linear",
  "display_p3",
  "a98_rgb",
  "prophoto_rgb",
  "rec2020",
  "xyz",
  "xyz_d50",
  "xyz_d65",
  "lab",
  "lch",
  "oklab",
  "oklch",
  "hwb",
  "hsl"
], wt = [
  ...xt,
  "cmyk",
  "named",
  "spot"
], Mt = [
  "system",
  "current_color",
  "transparent"
], ro = [
  ...wt,
  ...Mt
], Ut = [
  "color_mix",
  "light_dark",
  "contrast_color",
  "relative"
], oo = [
  "literal",
  ...Ut,
  "system",
  "current_color",
  "transparent"
], no = [
  "flatten_on_white",
  "flatten_on_rich_black",
  "error",
  "preserve"
];
export {
  re as $,
  Wt as A,
  Je as B,
  qr as C,
  qt as D,
  de as E,
  v as F,
  ae as G,
  Qr as H,
  Ye as I,
  S as J,
  pe as K,
  q as L,
  Tt as M,
  I as N,
  J as O,
  Te as P,
  Yt as Q,
  x as R,
  Tr as S,
  Rr as T,
  kr as U,
  X as V,
  j as W,
  Y as X,
  Kt as Y,
  Jt as Z,
  W as _,
  Oe as a,
  Ur as a$,
  st as a0,
  B as a1,
  $ as a2,
  zt as a3,
  je as a4,
  Xt as a5,
  jt as a6,
  or as a7,
  et as a8,
  sr as a9,
  Bt as aA,
  ur as aB,
  tt as aC,
  xt as aD,
  no as aE,
  wt as aF,
  Ut as aG,
  zr as aH,
  Kr as aI,
  Gr as aJ,
  Wr as aK,
  $r as aL,
  Br as aM,
  Hr as aN,
  Vr as aO,
  Fr as aP,
  Dr as aQ,
  Lr as aR,
  vr as aS,
  Nr as aT,
  Pr as aU,
  Cr as aV,
  gr as aW,
  yr as aX,
  Or as aY,
  Ar as aZ,
  Sr as a_,
  Gt as aa,
  M as ab,
  dr as ac,
  St as ad,
  Ae as ae,
  rr as af,
  V as ag,
  Z as ah,
  fr as ai,
  dt as aj,
  me as ak,
  ut as al,
  ir as am,
  Ee as an,
  rt as ao,
  cr as ap,
  tr as aq,
  nr as ar,
  _r as as,
  ve as at,
  Le as au,
  ne as av,
  at as aw,
  _t as ax,
  lt as ay,
  ct as az,
  Re as b,
  Mr as b0,
  wr as b1,
  xr as b2,
  eo as b3,
  Jr as b4,
  Zr as b5,
  Xr as b6,
  jr as b7,
  Yr as b8,
  Pt as b9,
  oo as ba,
  ro as bb,
  to as bc,
  Mt as bd,
  Ir as be,
  Ge as c,
  Zt as d,
  G as e,
  De as f,
  ze as g,
  ar as h,
  Ce as i,
  lr as j,
  ke as k,
  Me as l,
  we as m,
  ie as n,
  Ne as o,
  er as p,
  br as q,
  ge as r,
  hr as s,
  Er as t,
  mr as u,
  pr as v,
  Qe as w,
  Qt as x,
  z as y,
  $t as z
};
